import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './LoadingSpinner.scss';

// General LoadingSpinner Component
const LoadingSpinner = () => {
  return (
    <div className="loading_overlay" data-testid="loading_overlay">
      <FontAwesomeIcon
        icon={faCircleNotch}
        data-testid="loading_spinner"
        className="loading_spinner"
      />
    </div>
  );
};

export default LoadingSpinner;
